<div class="container">
  <div class="row no-gutters">
    <div class="col-12">

      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>{{ condition ? 'lblEditDiagnoseCheckList' : 'lblAddDiagnoseCheckList'}}</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
            </a>
        </div>
        
      </div>

     
      <form [formGroup]="addDiagnoseCheckListForm" (ngSubmit)="onSubmit()">
        <div class="scrollbar">
          <div class="card-content">
            <div class="card-body p-0">
              <div class="form-row">
                <div class="col-3 af-form-group">
                  <label for="name" translate>lblSequence</label>
                  <div class='lbl-info'>
                    <input formControlName="Sequence" class="form-control mb-2" placeholder="Sequence Number" pattern="^[0-9]{1,7}$">
                    <div *ngIf="cpf.Sequence.invalid && (cpf.Sequence.dirty || cpf.Sequence.touched)"
                      class="help-block text-danger">
                      <div *ngIf="cpf.Sequence.errors.min" translate>
                        lblMinimumRequiredNumber
                      </div>
                      <div *ngIf="cpf.Sequence.errors.max" translate>
                        lblMaximunRequiredNumber
                      </div>
                      </div>
                  </div>
                </div>

                <div class="w-100 col-12" *ngIf="t">
                  <div *ngFor="let ticket of t.controls; let i = index">
                    <div class="form-row" [formGroup]="ticket">
                      <div class="col-6 af-form-group">
                        <label for="name"><span translate>lblName</span><span>&nbsp;<span translate>lblIn</span>
                            {{languageList[i].value}}</span>
                          <strong class="mlt6 required"> * </strong> </label>
                        <div class="lbl-info">
                          <input formControlName="name" class="form-control mb-2" maxlength="150">
                          <div *ngIf="cpf.Service.touched && (cpf.Service.errors?.required)"
                            class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                              aria-hidden="true"></em>
                            lblCheckListNameRequired
                          </div>
                        </div>
                      </div>

                      <div class="col-6 af-form-group" style="display: none;">
                        <label for="languageId" translate>Language Id</label>
                        <div class="lbl-info">
                          <input formControlName="languageId" class="form-control mb-2" [ngModel]="languageList[i].id"
                            maxlength="30">
                        </div>
                      </div>

                      <div class="col-6 af-form-group">
                        <label for="description"><span translate>lblDescription</span><span>&nbsp;<span translate>lblIn</span>
                            {{languageList[i].value}}</span>
                          <strong class="mlt6 required"> * </strong> </label>
                        <div class='lbl-info'>
                          <input formControlName="description" class="form-control mb-2" maxlength="500">
                          <div *ngIf="cpf.Service.touched && (cpf.Service.errors?.required)"
                            class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                              aria-hidden="true"></em>
                            lblCheckListDesRequired
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
  
                <div class="col-12 af-form-group">
                  <div class="lbl-info ml-2">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input" id="IsActive" formControlName="IsActive">
                      <label class="custom-control-label" for="IsActive" translate>lblDisplayInDWO</label>
                    </div>
                  </div>
                </div>
                <div class="col-12 af-form-group" *ngIf="condition">
                  <label for="name" translate>lblServices</label>
                  <div *ngIf="selectedServices && selectedServices.length > 0" class="">
                    <ul class="mb-3">
                      <li *ngFor="let item of selectedServices;let i = index" class="btn btn-outline-dark p-2 mr-2 mb-2">
                        {{ item.name }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-3 bg-light pp-footer-top-brdr">
        <div class="row">
          <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
            <button class="btn btn-primary btn-lg mr-sm-2" aria-label="Center Align" *ngIf="condition" translate [disabled]="!addDiagnoseCheckListForm.valid">
              <em class="far fa-save font16 align-top mr-2"></em>
              lblSaveChanges</button>
              <button class="btn btn-primary btn-lg mr-sm-2" aria-label="Center Align"  *ngIf="!condition" translate [disabled]="!addDiagnoseCheckListForm.valid">
                <em class="fa fa-plus font16 align-top mr-2"></em>
                lblAdd</button>
            <a (click)="OnClose()" type="reset" class="btn btn-secondary btn-lg" translate>lblCancel</a>
          </div>
        </div>
      </div>
      </form>
    </div>
  </div>
</div>